/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAuditLogs} from '../api'

 export const useQueryGetAuditLogs = createReactQueryHook('getAuditLogs', getAuditLogs)
